module.exports = __webpack_public_path__ + "static/media/wpp.953a8c3e.png";